<template>
  <div class="row mx-auto">
    <div class="col-12 col-md-6 p-3 mx-auto">
      <h1 class="mt-4 mb-4 text-center">Import {{ title }} en masse</h1>
      <section class="mt-3 mb-3">
        <b-card>
          <h4 class="text-center">Choisir un fichier CSV</h4>
          <gwzCsvForm
            :serviceName="importName"
            :endpointName="`import${strUcFirst(importName)}Csv`"
          ></gwzCsvForm>
          <h3>Le format du fichier doit être:</h3>
          <b-form-textarea
            :value="exemple(importName)"
            id="textarea-rows"
            placeholder="Tall textarea"
            rows="8"
            readonly
          ></b-form-textarea>
        </b-card>
      </section>
    </div>
  </div>
</template>

<script>
import gwzCsvForm from "@/components/gwzCsvForm";
import exempleImport from "@/dataFixtures/exempleImport";
export default {
  name: "ImportCsv",
  props: {
    importName: {
      type: String,
      default: "",
      required: true
    }
  },
  computed: {
    title() {
      return this.importName === "attributes"
        ? "attributs"
        : this.importName === "categories"
        ? "catégories"
        : this.importName === "mappings"
        ? "mappings"
        : "valeurs";
    }
  },
  components: {
    gwzCsvForm
  },
  methods: {
    exemple(importName) {
      return exempleImport[importName];
    },
    strUcFirst(importNamet) {
      return (importNamet + "").charAt(0).toUpperCase() + importNamet.substr(1);
    }
  }
};
</script>

<style></style>
